export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5005.997eff02.jpg";